import styled, { css } from "styled-components";
import { Registry } from "@diana-ui/registry";
export var Fieldset = /*#__PURE__*/ styled.fieldset.withConfig({
  displayName: "TextInputstyle__Fieldset"
})(_ref => {
  var { theme, disabled, hasError } = _ref;
  return css(
    ["position:relative;height:38px;display:flex;padding:2px 8px;min-inline-size:auto;", " ", ""],
    disabled && css(["background-color:", ";"], theme.colors.grey.grey25),
    hasError && css(["border-color:", ";"], theme.colors.alert.alert100)
  );
});
/**
 * Text's input legend component
 */

export var Legend = /*#__PURE__*/ styled.legend.withConfig({
  displayName: "TextInputstyle__Legend"
})(_ref2 => {
  var { theme, focusLabel, label, isFocused, hasContent, legendWidth } = _ref2;
  return css(
    [
      "width:0;pointer-events:none;padding:0;text-align:left;opacity:0;transition:width 0.15s;line-height:11px;height:0;",
      " ",
      " @media screen and (max-width:",
      "px){height:3px;}"
    ],
    (focusLabel || isFocused) && label && hasContent && css(["padding:0 2px;"]),
    (focusLabel || isFocused || hasContent) && {
      width: legendWidth,
      padding: "0 2px"
    },
    theme.breakpoints.MOBILE_1
  );
});
export var HiddenLabel = /*#__PURE__*/ styled.span.withConfig({
  displayName: "TextInputstyle__HiddenLabel"
})(_ref3 => {
  var { theme } = _ref3;
  return css(
    ["opacity:0;position:absolute;pointer-events:none;height:0;", ""],
    theme.typography.label
  );
});
export var LabelContainer = /*#__PURE__*/ styled.div.withConfig({
  displayName: "TextInputstyle__LabelContainer"
})(_ref4 => {
  var { theme } = _ref4;
  return css(
    [
      "position:absolute;top:0;left:",
      ";height:40px;pointer-events:none;display:flex;align-items:center;"
    ],
    theme.spaceUnit.xxs
  );
});
export var TextLabel = /*#__PURE__*/ styled.div.withConfig({
  displayName: "TextInputstyle__TextLabel"
})(_ref5 => {
  var { theme, isFocused, focusLabel, hasContent, labelWithPrefix } = _ref5;
  return css(
    [
      "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:",
      ";padding:0 ",
      ";transition:transform 0.1s,font-size 0.1s,padding 0.1s;transition-timing-function:ease-in;pointer-events:none;",
      " ",
      " ",
      ""
    ],
    theme.colors.grey.grey100,
    theme.spaceUnit.xxs,
    theme.typography.body,
    (focusLabel || isFocused || hasContent) &&
      css(
        ["transform:translate(2px,-21px);padding-left:", ";", ""],
        theme.spaceUnit.xxs,
        theme.typography.label
      ),
    labelWithPrefix && css(["padding-left:", ";"], theme.spaceUnit.xl)
  );
});
export var InputContainer = /*#__PURE__*/ styled.div.withConfig({
  displayName: "TextInputstyle__InputContainer"
})(() => css(["display:flex;align-items:center;flex:1;"]));
export var Input = /*#__PURE__*/ styled.input.withConfig({
  displayName: "TextInputstyle__Input"
})(_ref6 => {
  var { theme, disabled } = _ref6;
  return css(
    ["outline:none;border:none;width:100%;height:35px;flex:1;", ";", ""],
    theme.typography.body,
    disabled && css(["background-color:", ";"], theme.colors.grey.grey25)
  );
});
export var PrefixWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "TextInputstyle__PrefixWrapper"
})(_ref7 => {
  var { theme } = _ref7;
  return {
    marginRight: theme.spaceUnit.xs
  };
});
export var SuffixWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "TextInputstyle__SuffixWrapper"
})(_ref8 => {
  var { theme } = _ref8;
  return {
    marginLeft: theme.spaceUnit.xs
  };
});
var Icon = Registry.get("Icon");
export var PrefixIcon = /*#__PURE__*/ styled(Icon).withConfig({
  displayName: "TextInputstyle__PrefixIcon"
})(_ref9 => {
  var { theme } = _ref9;
  return css(["margin-right:", ";"], theme.spaceUnit.xs);
});
export var SuffixIcon = /*#__PURE__*/ styled(Icon).withConfig({
  displayName: "TextInputstyle__SuffixIcon"
})(_ref10 => {
  var { theme } = _ref10;
  return css(["margin-left:", ";"], theme.spaceUnit.xs);
});
